module.exports = require("aws4");